export default {
    textStyles: [
        {
            label: 'Stil 1',
            value: 'font-1'
        },
        {
            label: 'Stil 2',
            value: 'font-2'
        },
        {
            label: 'Stil 3',
            value: 'font-3'
        },
        {
            label: 'Stil 4',
            value: 'font-4'
        },
        {
            label: 'Stil 5',
            value: 'font-5'
        },
        {
            label: 'Stil 6',
            value: 'font-6'
        },
    ],
    layoutOptions: [
        {
            label: 'Stående',
            value: 'vertical'
        },
        {
            label: 'Liggande',
            value: 'horizontal'
        }
    ],
    sizeOptions: [
        {
            label: 'A4',
            value: 'a4',
        },
        {
            label: '30x40cm',
            value: '30x40cm',
        },
        {
            label: '50x70cm',
            value: '50x70cm',
        },
    ],
    presets: [
        {
            label: 'Sverige',
            value: 'sverige',
        },
        {
            label: 'Europa',
            value: 'europa1',
        },
        {
            label: 'Norden',
            value: 'europa2',
        },
        {
            label: 'Världen',
            value: 'varlden',
        },
    ],
}